import sidebarData from '@/data/sidebar.json';
import type { SidebarData } from '@/data/types';

export const useSidebarData = () => {
  return {
    sidebarData: sidebarData as SidebarData
  };
};